import React from "react";

import { isNone } from "~/common/assert";
import { selectUser } from "~/slices/user";
import { useAppSelector } from "~/store";
import type { TUser } from "~/types/user";

type PersonNameProps = Omit<FormatPersonNameProps, "user"> & {
  className?: string;
  as?: React.ElementType;
};

export function PersonName({ as: Tag = "span", className, ...props }: PersonNameProps) {
  const user = useAppSelector(selectUser);

  return (
    <Tag data-matomo-mask data-hj-suppress className={className}>
      {formatPersonName({ ...props, user })}
    </Tag>
  );
}

type FormatPersonNameProps = {
  person?: {
    account_id?: number;
    first_name: string;
    middle_name?: string | null;
    last_name: string;
  };
  user?: Partial<TUser>;
  useMiddleName?: boolean;
  isDoctor?: boolean;
};

export function formatPersonName({
  person,
  useMiddleName,
  isDoctor,
  user,
}: FormatPersonNameProps): string {
  if (!person) return "";
  let { first_name, middle_name, last_name } = person;
  if (!middle_name || !useMiddleName || isNone(middle_name)) {
    middle_name = "";
  }

  if (!isDoctor && user) {
    isDoctor = person.account_id == user.account_id;
  }

  const name = [last_name, first_name, middle_name].filter(Boolean);
  return name.join(" ");
}
